import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { FP } from "./tokens";

// Compact metric card used across all FinancePro report headers.
// Left accent bar uses `accent`, while the icon chip uses a tinted variant of it.
export default function StatCard({ label, value, icon: Icon, accent = FP.color.navy }) {
  return (
    <Card
      elevation={0}
      sx={{
        height: "100%",
        borderRadius: 2.5,
        border: `1px solid ${FP.color.border}`,
        bgcolor: FP.color.cardBg,
        boxShadow: FP.shadow.soft,
        overflow: "hidden",
        position: "relative",
        transition: "all 0.2s ease",
        "&:hover": { boxShadow: FP.shadow.md, transform: "translateY(-2px)" },
        "&::before": {
          content: '""',
          position: "absolute",
          left: 0,
          top: 0,
          bottom: 0,
          width: 4,
          bgcolor: accent,
        },
      }}
    >
      <CardContent sx={{ p: 2.4, "&:last-child": { pb: 2.4 } }}>
        <Box display="flex" justifyContent="space-between" alignItems="flex-start" gap={1.5}>
          <Box flex={1} minWidth={0}>
            <Typography
              sx={{
                color: FP.color.textSecondary,
                fontWeight: 700,
                letterSpacing: "0.1em",
                textTransform: "uppercase",
                fontSize: "0.66rem",
                mb: 1,
              }}
            >
              {label}
            </Typography>
            <Typography
              sx={{
                fontWeight: 800,
                color: FP.color.textPrimary,
                fontVariantNumeric: "tabular-nums",
                lineHeight: 1.2,
                letterSpacing: "-0.02em",
                fontSize: "1.4rem",
                wordBreak: "break-word",
              }}
            >
              {value}
            </Typography>
          </Box>
          {Icon ? (
            <Box
              sx={{
                flexShrink: 0,
                width: 42,
                height: 42,
                borderRadius: 1.4,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: `${accent}14`,
                color: accent,
              }}
            >
              <Icon sx={{ fontSize: 20 }} />
            </Box>
          ) : null}
        </Box>
      </CardContent>
    </Card>
  );
}
